import React from 'react'
import { Box, Typography } from '@mui/material';

interface Props {
    totalCount: number
    rowsPerPage: number
    page: number
    countUnit: string
    noResultMessage: string
}

export type SearchResultCountDisplayProps = Partial<Props>

const SearchResultCountDisplay: React.FC<SearchResultCountDisplayProps> = props => {
    const count = props.totalCount || 0

    if (count > 0) {
        return null
    }
    if (!props.noResultMessage) {
        return null
    }
    return (
        <Box mt={'5px'} ml={'10px'}>
            <Typography variant={'body2'}>
                {props.noResultMessage}
            </Typography>
        </Box>
    )
}

SearchResultCountDisplay.displayName = 'SearchResultCountDisplay'
export default SearchResultCountDisplay
